import script from "./PublicationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationsPage.vue?vue&type=script&setup=true&lang=js"

import "./PublicationsPage.vue?vue&type=style&index=0&id=94e12cf2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94e12cf2"]])

export default __exports__